export const generateUid = () => {
	return Math.random().toString(16).slice(2);
};
